import { useEffect } from "react";
import type { LegalPageDef } from "../content/bifrost-legal";

export function LegalPage({ page }: { page: LegalPageDef }) {
  useEffect(() => {
    document.title = `${page.title} — Odingard`;
  }, [page.title]);

  return (
    <main className="page" id="main">
      <section className="page__hero">
        <p className="page__eyebrow">Bifrost</p>
        <h1>{page.title}</h1>
        <p className="page__lede">{page.lede}</p>
        <p className="page__lede">Last updated {page.updated}.</p>
      </section>
      {page.sections.map((s) => (
        <section className="pdp__section" key={s.heading}>
          <h2>{s.heading}</h2>
          {s.body.map((para) => (
            <p className="pdp__body" key={para.slice(0, 40)}>
              {para}
            </p>
          ))}
        </section>
      ))}
    </main>
  );
}
